export const DEFAULT_HOSTNAME = 'command.cargomatic.com';
